import React from 'react'
import ArSparkBar from './ArSparkBar'
import ArRowMenu from './ArRowMenu'
import { pastDueOf, currencyFormat, healthOf, autoNote, ptpTags, daysAgo } from './arAgingModel'

const HEALTH_DOT = { bad: 'var(--danger)', warn: 'var(--warn)', primary: 'var(--ok)' }

const lastActivityDays = (company) => daysAgo(company.lastActivityAt)

// One company card in the list. Same 5-col grid as the column header.
const ArCompanyRow = ({
  company, selected, checked, excluded, ptp, menuOpen,
  onSelect, onToggleCheck, onToggleMenu, actions
}) => {
  const buckets = company.buckets
  const pastDue = pastDueOf(buckets)
  const health = healthOf(company, buckets, ptp)
  const note = autoNote(company, buckets, { excluded })
  const tags = ptpTags(company, ptp, lastActivityDays(company))

  return (
    <div className={`ar-row ${selected ? 'selected' : ''}`} onClick={() => onSelect(company)}>
      <span className="ar-row-cell ar-row-check" onClick={event => event.stopPropagation()}>
        <input
          type="checkbox"
          className="ar-check"
          checked={checked}
          onChange={() => onToggleCheck(company)}
          aria-label={`Select ${company.companyName}`}
        />
      </span>

      <div className="ar-row-cell ar-row-main">
        <div className="ar-row-name-line">
          <span className="ar-health-dot" style={{ background: HEALTH_DOT[health.tone] }} title={health.label} />
          <span className="ar-row-name" title={company.companyName}>{company.companyName}</span>
          {company.pauseRequested && <span className="ar-pill ar-pill-warn">PAUSED</span>}
        </div>
        <div className="ar-row-sub">
          <span className="ar-row-note">{note}</span>
          {tags.map((tag, index) => (
            <span key={index} className={`ar-row-tag tone-${tag.tone}`}>{tag.text}</span>
          ))}
        </div>
      </div>

      <span className="ar-row-cell ar-row-spark">
        <ArSparkBar buckets={buckets} />
      </span>

      <span className={`ar-row-cell ar-row-pastdue ${pastDue > 0 ? 'risk' : ''}`}>
        {currencyFormat(pastDue)}
      </span>

      <span className="ar-row-cell ar-row-kebab" onClick={event => event.stopPropagation()}>
        <button
          type="button"
          className="ar-kebab-btn"
          aria-label="Actions"
          onClick={() => onToggleMenu(company)}
        >···</button>
        {menuOpen && <ArRowMenu company={company} actions={actions} onClose={() => onToggleMenu(null)} />}
      </span>
    </div>
  )
}

export default ArCompanyRow
